import React, { Component } from 'react';
import PropTypes from 'prop-types';
import NumberFormat from 'react-number-format';
import Moment from 'react-moment';

import { deepEqual } from './../../utils';

import './styles.css';

class VehicleRevenue extends Component {
  shouldComponentUpdate(nextProps) {
    return !deepEqual(this.props, nextProps);
  }

  render() {
    const { lastTrip, freightAmount } = this.props;
    return (
      <div className="vehicle-revenue-wrapper">
        <div className="primary">
          <NumberFormat
            value={freightAmount}
            thousandSeparator="."
            decimalSeparator=","
            decimalScale={0}
            displayType="text"
            prefix="R$ "
          />
        </div>
        <div className="secondary">
          {lastTrip.issuedAt ? (
            <small>
              <NumberFormat
                value={lastTrip.freightAmount || 0}
                thousandSeparator="."
                decimalSeparator=","
                decimalScale={0}
                displayType="text"
                prefix="+R$ "
              />
              {' faturado '}
              <Moment fromNow>
                {lastTrip.issuedAt}
              </Moment>
            </small>
          ) : (
            <small>Últ. viagem não encontrada</small>
          )}
        </div>
        <div className="subtitle">
          <small>{lastTrip.originCity && `${lastTrip.originCity} x ${lastTrip.destinationCity}`}</small>
        </div>
      </div>
    );
  }
}

VehicleRevenue.propTypes = {
  freightAmount: PropTypes.number.isRequired,
  lastTrip: PropTypes.object.isRequired,
};

export default VehicleRevenue;



// WEBPACK FOOTER //
// ./src/Vehicle/VehicleRevenueCell/index.js